<script>
export default {
  data: () => ({
    isShown: true,
    isLoading: false,
    isSuccess: false,
    ownerPhone: null,
  }),
  computed: {
    authStore() {
      return this.$store.getters['auth/store'];
    },
    isNotPercentPlan() {
      return this.$store.getters['auth/isNotPercentPlan'];
    },
  },
  methods: {
    onSave() {
      this.isLoading = true;
      this.$store.dispatch('auth/updateStore', { owner_phone: this.ownerPhone })
        .then(() => (this.isSuccess = true))
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>

<template>
  <form
    v-if="(isNotPercentPlan && !authStore.owner_phone) || isSuccess"
    v-show="isShown"
    class="card is-primary is-fixed mw-460"
    style="right: 20px; bottom: 100px; z-index: 20"
    @submit.prevent="onSave">
    <header class="card-header">
      <p class="card-header-title">📞 Nous avons besoin de votre numéro !</p>
      <b-button
        type="is-text"
        icon-left="times"
        aria-label="fermer"
        @click="isShown = false"
      />
    </header>
    <div class="card-content">
      <div v-show="isSuccess" class="notification is-success mb-0">
        Merci ! C'est enregistré.
        <br>
        Vous pouvez fermer cette fenêtre.
      </div>
      <div v-show="!isSuccess" class="content">
        <p>
          Pour mieux vous accompagner, merci d’indiquer votre numéro de téléphone
          avec l’indicatif international (ex. : +33 pour la France).
        </p>
        <p>
          👉 Ce numéro ne sera utilisé que pour vous contacter
          en cas de besoin lié à notre support client.
        </p>
        <b-field label="Téléphone mobile" label-for="owner-phone">
          <b-input
            type="tel"
            id="owner-phone"
            placeholder="+33600000000"
            required
            pattern="^\+(?!0+$)(?![1-9]0+$)\d{7,15}$"
            v-model="ownerPhone"
          />
        </b-field>
      </div>

      <div v-show="!isSuccess" class="buttons is-right">
        <b-button type="is-primary" native-type="submit" :loading="isLoading">
          Envoyer
        </b-button>
      </div>
    </div>
  </form>
</template>
